import SerchIcon from "@mui/icons-material/Search";
import { Box, TextField, Typography } from "@mui/material";

import isSesi from "../utils/envUtils";

interface SearchTextFieldProps {
  handleSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  title: string;
  placeholder: string;
}

export default function SearchTextField({
  handleSearch,
  title,
  placeholder,
}: SearchTextFieldProps): React.JSX.Element {
  if (isSesi()) {
    return <></>;
  }

  return (
    <>
      <Typography
        color="text.secondary"
        fontSize={12}
        fontWeight={400}
        sx={{ paddingLeft: "16px", marginBottom: "8px" }}
        variant="subtitle2"
      >
        {title}
      </Typography>
      <Box
        sx={{ paddingLeft: "16px", paddingRight: "16px", marginBottom: "24px" }}
      >
        <TextField
          color="primary"
          fullWidth
          onChange={handleSearch}
          placeholder={placeholder}
          size="small"
          slotProps={{
            input: {
              endAdornment: <SerchIcon color="primary" />,
            },
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "text.disabled",
                borderWidth: "0.1px",
              },
              "&:hover fieldset": {
                borderColor: "text.disabled",
                borderWidth: "0.1px",
              },
              "&.Mui-focused fieldset": {
                borderColor: "text.disabled",
                borderWidth: "0.1px",
              },
            },
            "& .MuiInputBase-input": {
              color: "text.secondary",
              fontSize: "16px",
              fontWeight: 400,
            },
          }}
          variant="outlined"
        />
      </Box>
    </>
  );
}
